/** Application-wide constants */

// Polling intervals (ms)
export const POLL_INTERVAL_MS: number = 10000;

// HTTP status codes
export const HTTP_UNAUTHORIZED: number = 401;
